<template>
  <div class="app">
    <div class="playground">
      <div class="hello-box">
        <div class="header clearfix">
          <div class="icon-status">
            <transition name="blink">
              <img :src="iconPath" :key="iconPath" alt />
            </transition>
          </div>
          <el-tooltip popper-class="help-tip" effect="dark" placement="bottom-end">
            <div slot="content">
              <span class="help-content">
                <i class="el-icon-service"></i>&ensp;186&ensp;7559&ensp;6040
              </span>
            </div>
            <span class="help fr">需要协助?</span>
          </el-tooltip>
        </div>

        <dark-box>
          <component :is="gate" @update="doUpdate"></component>
        </dark-box>
        <div class="gap"></div>
        <link-box class="link-box" :type="linkState" @update="doUpdate"></link-box>
      </div>
    </div>
  </div>
</template>

<script>
import linkBox from './components/linkBox.vue';
import darkBox from './components/darkBox.vue';

import checkT from './components/checkT.vue';

import privacyA from './components/privacyA.vue';

import bindM from './components/bindM.vue';
import bindS from './components/bindS.vue';

import loginP from './components/loginP.vue';
import loginM from './components/loginM.vue';

import signupA from './components/signupA.vue';
import signupS from './components/signupS.vue';

import recoveryA from './components/recoveryA.vue';
import recoveryB from './components/recoveryB.vue';
import recoveryS from './components/recoveryS.vue';

import '@/assets/styles/modify.scss';
import { getCookie } from '@/uitls/index';
import axios from 'axios';

import mixinRedirect from './utils/mixinRedirect';

export default {
  components: {
    linkBox,
    darkBox,
    checkT,
    bindM,
    bindS,
    loginP,
    loginM,
    signupA,
    signupS,
    recoveryA,
    recoveryB,
    recoveryS,
    privacyA
  },
  mixins: [mixinRedirect],
  watch: {
    $route(to, from) {
      if (to.path == '/login') {
        this.doUpdate('loginP');
      } else if (to.path == '/signup') {
        this.doUpdate('signupA');
      } else if (to.path == '/recovery') {
        this.doUpdate('recoveryA');
      }
    }
  },
  computed: {},
  data() {
    return {
      linkState: 0,
      gate: 'checkT',
      iconPath: '',

      linkDict: {
        checkT: 0,
        loginP: 2,
        loginM: 2,
        signupA: 1,
        signupS: 0,
        recoveryA: 3,
        recoveryB: 3,
        recoveryS: 0,
        bindM: 0,
        bindS: 0,
        privacyA: 4
      },
      iconDict: {
        checkT: require('./../../assets/images/img-check.png'),
        loginP: require('./../../assets/images/img-computer.png'),
        loginM: require('./../../assets/images/img-iphone.png'),
        signupA: require('./../../assets/images/img-resiter.png'),
        recoveryA: require('./../../assets/images/img-openlock.png'),
        recoveryB: require('./../../assets/images/img-lock.png'),
        bindM: require('./../../assets/images/img-bindiphone.png')
      }
    };
  },
  methods: {
    doUpdate(name) {
      this.gate = name;
      this.linkState = this.linkDict[name];
      this.iconDict[name] && (this.iconPath = this.iconDict[name]);
    },

    // verify TOKEN
    verifyToken() {
      let token = getCookie('accesstoken');
      if (token) {
        this.$http
          .post(
            '/user-server/user/checkToken',
            {},
            {
              headers: {
                token: token
              },
              interceptorDisabled: true
            }
          )
          .then(res => {
            if (res.data.code == 200) {
              this.doRedirect();
            } else {
              // TODO: remove cookies ###
              this.doUpdate('loginP');
            }
          })
          .catch(err => {
            console.log('ERROR', err);
            this.doUpdate('loginP');
          });
      } else {
        this.doUpdate('loginP');
      }
    }
  },

  created() {
    let path = this.$route.path;
    if (path == '/login') {
      // TODO: checkT
      // this.doUpdate("loginP");
      this.doUpdate('checkT');
    } else if (path == '/signup') {
      this.doUpdate('signupA');
    } else if (path == '/recovery') {
      this.doUpdate('recoveryA');
    }
  },

  mounted() {
    if (this.$route.path == '/login') {
      this.verifyToken();
    }
  }
};
</script>

<style lang="scss" scoped>
@import './index.scss';
.help-content {
  font-size: 16px;
}
</style>




// WEBPACK FOOTER //
// src/views/index/index.vue